import Box from "@mui/joy/Box";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Stack from "@mui/joy/Stack";
import Table from '@mui/joy/Table';
import Typography from "@mui/joy/Typography";

const INK = "#15171C";
const MUTED = "#9AA0A6";
const ZEBRA = "#F7F7F8";
const LINE = "#ECECEE";

const AllTimeCard = (data) => {
    const user_data = data.users;

    return (
        <Card
            variant="plain"
            sx={{
                backgroundColor: '#FFFFFF',
                width: '100%',
                minWidth: 0,
                maxWidth: '100%',
                alignSelf: 'stretch',
                boxSizing: 'border-box',
                borderRadius: '28px',
                p: 3,
                overflow: 'hidden',
            }}
        >
            <CardContent>
                <Stack direction="column" spacing={0}>
                    <Typography level='h3' sx={{ textAlign: 'left', color: INK, fontWeight: 700 }}>
                        Most Active Users
                    </Typography>
                    <Typography level='body-sm' sx={{ textAlign: 'left', color: MUTED, fontWeight: 600 }}>
                        All Time
                    </Typography>
                </Stack>
            </CardContent>

            <CardContent sx={{ minWidth: 0 }}>
                <Box sx={{ width: '100%', minWidth: 0, overflowX: 'auto' }}>
                    <Table
                        stickyHeader
                        size="md"
                        sx={{
                            width: '100%',
                            '--TableCell-borderColor': LINE,
                            '--TableCell-paddingY': '4px',
                            '--TableCell-paddingX': '16px',
                            '& thead th': {
                                backgroundColor: '#FFFFFF',
                                color: MUTED,
                                fontWeight: 700,
                                fontSize: '11px',
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                            },
                            '& thead th:last-of-type': {
                                textAlign: 'right',
                            },
                            '& tbody td': {
                                color: INK,
                                borderBottom: 'none',
                            },
                            '& tbody td:last-of-type': {
                                textAlign: 'right',
                                color: MUTED,
                                fontVariantNumeric: 'tabular-nums',
                            },
                            '& tbody tr:nth-of-type(odd)': {
                                backgroundColor: ZEBRA,
                            },
                        }}
                    >
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Messages</th>
                            </tr>
                        </thead>
                        <tbody>
                            {user_data.map((user) => (
                                <tr key={user['fan_id']}>
                                    <td>{user['fan']}</td>
                                    <td>{user['message_count']}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Box>
            </CardContent>
        </Card>
    );
}

export default AllTimeCard;
